module.exports = __webpack_public_path__ + "h5/img/bs_15.be0d158d.jpeg";